import { useEffect, useState } from "react";

// icon
import BulbIcon from "./BulbIcon";

export const NotificationToast = ({
  toast = { message: "", type: "" },
  onClose,
}) => {
  const { message, type } = toast;
  const [visible, setVisible] = useState(false);

  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 300);
  };

  useEffect(() => {
    if (toast?.message) {
      setVisible(true);
    }
  }, [toast]);

  const typeStyles = {
    info: "bg-[#F6FFF9] text-[#373737] border-[#DC7609]",
  };

  return (
    <div
      className={`flex items-center w-full max-w-sm p-4 border rounded-lg shadow-md transition-all duration-300 ease-in-out z-[99]
        ${typeStyles[type]} absolute top-[7px] left-1/3 transform
        ${
          visible
            ? "animate-slideInDown opacity-100"
            : "animate-slideOutUp opacity-0"
        }`}
      role="alert"
    >
      <div className="flex-shrink-0">
        <BulbIcon />
        {type === "success" && (
          <div
            style={{
              background: "linear-gradient(180deg, #48CA93 0%, #48BACA 100%)",
            }}
            className="py-[5px] px-1 rounded-md"
          >
            <svg
              width="10"
              height="8"
              viewBox="0 0 10 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.5 4.5L3.5 6.5L8.5 1.5"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        )}
        {type === "error" && (
          <div
            style={{
              background: "linear-gradient(180deg, #E88B76 0%, #CA5048 100%)",
            }}
            className="py-1.5 px-1.5 rounded-md"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="8"
              height="8"
              viewBox="0 0 8 8"
              fill="none"
            >
              <path
                d="M6.99998 1.00002L1 7M0.999975 1L6.99995 6.99998"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </div>
        )}
      </div>

      <div className="ml-3 text-[14px] font-mont font-[500]">{message}</div>

      <button
        onClick={handleClose}
        className="ml-auto bg-transparent text-gray-500 hover:text-gray-900 rounded-lg p-1"
        aria-label="Close"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 4.00004L4 14M3.99996 4L13.9999 14"
            stroke="#373737"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </button>
    </div>
  );
};
